function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

module.exports = _taggedTemplateLiteral;


//////////////////
// WEBPACK FOOTER
// ./~/react-select3/~/@babel/runtime/helpers/taggedTemplateLiteral.js
// module id = 236
// module chunks = 0